import React, { useState } from 'react';
import { XIcon, TagIcon, PlusIcon, HelpCircleIcon, MessageCircleIcon } from 'lucide-react';
const TeacherNewTopic = ({
  onClose,
  onAddTopic
}) => {
  const [topicData, setTopicData] = useState({
    title: '',
    category: 'Genel',
    content: '',
    tags: [],
    type: 'soru-cozum' // Default to 'soru-cozum'
  });
  const [newTag, setNewTag] = useState('');
  const categories = ['Genel', 'Matematik', 'Fizik', 'Kimya', 'Biyoloji', 'Tarih', 'Coğrafya', 'Edebiyat', 'İngilizce', 'Diğer'];
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setTopicData({
      ...topicData,
      [name]: value
    });
  };
  const handleAddTag = () => {
    if (newTag.trim() && !topicData.tags.includes(newTag.trim())) {
      setTopicData({
        ...topicData,
        tags: [...topicData.tags, newTag.trim()]
      });
      setNewTag('');
    }
  };
  const handleRemoveTag = tag => {
    setTopicData({
      ...topicData,
      tags: topicData.tags.filter(t => t !== tag)
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Here would be the API call to create a new topic
    if (onAddTopic) {
      onAddTopic(topicData);
    }
    onClose();
  };
  return <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-684">
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-emerald-500 w-full max-w-2xl" data-id="element-685">
        <div className="relative p-6 bg-black rounded-lg max-h-[90vh] overflow-y-auto" data-id="element-686">
          <div className="flex justify-between items-center mb-6" data-id="element-687">
            <h2 className="text-xl font-semibold" data-id="element-688">Yeni Konu Oluştur</h2>
            <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-800" data-id="element-689">
              <XIcon size={20} data-id="element-690" />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-691">
            <div data-id="element-692">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-693">
                Konu Tipi
              </label>
              <div className="grid grid-cols-2 gap-3" data-id="element-694">
                <button type="button" className={`flex items-center justify-center p-3 rounded-md border ${topicData.type === 'soru-cozum' ? 'bg-emerald-600/20 border-emerald-500 text-emerald-400' : 'bg-gray-900 border-gray-700 text-gray-300 hover:border-gray-600'}`} onClick={() => setTopicData({
                ...topicData,
                type: 'soru-cozum'
              })} data-id="element-695">
                  <HelpCircleIcon size={18} className="mr-2" data-id="element-696" />
                  <span data-id="element-697">Soru Çözüm</span>
                </button>
                <button type="button" className={`flex items-center justify-center p-3 rounded-md border ${topicData.type === 'diger' ? 'bg-emerald-600/20 border-emerald-500 text-emerald-400' : 'bg-gray-900 border-gray-700 text-gray-300 hover:border-gray-600'}`} onClick={() => setTopicData({
                ...topicData,
                type: 'diger'
              })} data-id="element-698">
                  <MessageCircleIcon size={18} className="mr-2" data-id="element-699" />
                  <span data-id="element-700">Diğer</span>
                </button>
              </div>
            </div>
            <div data-id="element-701">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-702">
                Konu Başlığı
              </label>
              <div className="relative p-[1px] rounded-md overflow-hidden bg-gradient-to-r from-emerald-600/40 to-emerald-500/40" data-id="element-703">
                <input type="text" name="title" value={topicData.title} onChange={handleChange} placeholder="Konu başlığını girin..." className="w-full bg-gray-900 rounded-md py-2 px-3 focus:outline-none" required data-id="element-704" />
              </div>
            </div>
            {topicData.type === 'soru-cozum' && <div data-id="element-705">
                <label className="block text-sm text-gray-400 mb-1" data-id="element-706">Ders</label>
                <div className="relative p-[1px] rounded-md overflow-hidden bg-gradient-to-r from-emerald-600/40 to-emerald-500/40" data-id="element-707">
                  <select name="category" value={topicData.category} onChange={handleChange} className="w-full bg-gray-900 rounded-md py-2 px-3 focus:outline-none" data-id="element-708">
                    {categories.map(category => <option key={category} value={category} data-id="element-709">
                        {category}
                      </option>)}
                  </select>
                </div>
              </div>}
            <div data-id="element-710">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-711">
                Etiketler
              </label>
              <div className="flex space-x-2 mb-2" data-id="element-712">
                <div className="relative p-[1px] rounded-md overflow-hidden bg-gradient-to-r from-emerald-600/40 to-emerald-500/40 flex-1" data-id="element-713">
                  <input type="text" value={newTag} onChange={e => setNewTag(e.target.value)} placeholder="Etiket ekle..." className="w-full bg-gray-900 rounded-md py-2 px-3 focus:outline-none" onKeyPress={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddTag();
                  }
                }} data-id="element-714" />
                </div>
                <button type="button" onClick={handleAddTag} className="bg-emerald-600 hover:bg-emerald-500 text-white p-2 rounded-md flex items-center transition-colors" data-id="element-715">
                  <PlusIcon size={20} data-id="element-716" />
                </button>
              </div>
              <div className="flex flex-wrap gap-2 mt-2" data-id="element-717">
                {topicData.tags.map((tag, index) => <div key={index} className="flex items-center bg-gray-800 text-emerald-400 px-2 py-1 rounded-full text-sm" data-id="element-718">
                    <TagIcon size={12} className="mr-1" data-id="element-719" />
                    {tag}
                    <button type="button" onClick={() => handleRemoveTag(tag)} className="ml-1 p-0.5 rounded-full hover:bg-gray-700" data-id="element-720">
                      <XIcon size={12} data-id="element-721" />
                    </button>
                  </div>)}
              </div>
            </div>
            <div data-id="element-722">
              <label className="block text-sm text-gray-400 mb-1" data-id="element-723">İçerik</label>
              <div className="relative p-[1px] rounded-md overflow-hidden bg-gradient-to-r from-emerald-600/40 to-emerald-500/40" data-id="element-724">
                <textarea name="content" value={topicData.content} onChange={handleChange} placeholder="Konu içeriğini yazın..." rows={8} className="w-full bg-gray-900 rounded-md py-2 px-3 focus:outline-none" required data-id="element-725"></textarea>
              </div>
            </div>
            <div className="flex justify-end space-x-3 pt-3" data-id="element-726">
              <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-md transition-colors" data-id="element-727">
                İptal
              </button>
              <button type="submit" className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-md transition-colors" data-id="element-728">
                Konuyu Oluştur
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default TeacherNewTopic;